import styled from "styled-components";
import hero from "../images/hero.png";
const Wrapper = styled.div`
  position: relative;
  /* Darker navy overlay for better text contrast/readability */
  background: linear-gradient(rgba(15, 44, 89, 0.92), rgba(15, 44, 89, 0.85)),
    url(${hero}), 
    radial-gradient(at 0% 0%, #0F2C59 0, transparent 50%), 
    radial-gradient(at 100% 100%, #153d7a 0, transparent 50%),
    #0F2C59;
  background-repeat: no-repeat;
  background-position: center 20%;
  background-size: cover;
  padding: 120px 0 80px; /* More top padding for nav spacing */
  width: 100%;
  min-height: 85vh; /* Taller hero specifically for desktop */
  display: flex;
  align-items: center;

  @media (max-width: 1020px) {
    padding: 100px 0 60px;
    min-height: auto;
  }

  .container {
    height: 100%;
    max-width: 900px;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    z-index: 10;

    .center {
      padding: 0 10px;

      h2 {
        font-family: 'Playfair Display', serif;
        font-size: 3.5rem;
        margin: 0 0 25px;
        color: #f1f1f1;
        font-weight: 700;
        line-height: 1.2;

        .colorfull {
          color: var(--secondary-color); /* Gold */
          font-style: italic;
        }

        @media (max-width: 760px) {
          font-size: 2.2rem;
        }
      }

      /* Credentials text */
      p:nth-of-type(1) {
        font-size: 1.2rem !important;
        color: var(--secondary-color) !important;
        font-weight: 700 !important;
        letter-spacing: 2px !important;
        text-transform: uppercase;
        margin-bottom: 20px !important;
        font-family: 'Lato', sans-serif;
      }

      /* Description text */
      .hero-description {
        font-size: 1.3rem !important;
        color: #e0e0e0 !important;
        line-height: 1.8 !important;
        max-width: 800px;
        margin: 0 auto 40px !important;
        font-weight: 300;

        @media (max-width: 760px) {
          font-size: 1.1rem !important;
          line-height: 1.6 !important;
        }
      }

      .btn {
        /* Already defined globally but modifying specific hero sizes if needed */
        font-size: 1.2rem;
        padding: 15px 40px;
        background-color: var(--secondary-color);
        border: 2px solid var(--secondary-color);
        color: var(--primary-color);
        
        &:hover {
          background-color: transparent;
          color: var(--secondary-color);
        }
      }
    }
  }

  .whatsapp-icon {
    z-index: 999;
    position: fixed;
    bottom: 25px;
    right: 25px;
    background: var(--secondary-color);
    color: var(--white);
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    transition: var(--transition);
    border: 3px solid white;

    svg {
       width: 32px;
       height: 32px;
    }

    &:hover {
      transform: scale(1.1) translateY(-5px);
      background: #25D366;
      border-color: #25D366;
      box-shadow: 0 15px 30px rgba(37, 211, 102, 0.3);
    }

    @media (max-width: 600px) {
      width: 55px;
      height: 55px;
      bottom: 20px;
      right: 20px;
      
      svg {
        width: 28px;
        height: 28px;
      }
    }
  }
`;

export default Wrapper;
